export default __webpack_public_path__ + "static/media/engage-module.89ce65fc.svg";